var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General / Navigation / FAQ"
  }, /*#__PURE__*/React.createElement("path", {
    id: "faq-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.2135 10.2925C10.5959 10.5137 11.0853 10.383 11.3065 10.0006C12.0721 8.89232 13.5521 10.368 12.3387 11.0893C12.1206 11.219 11.8354 11.4348 11.6184 11.6992C11.413 11.9495 11.2244 12.2937 11.2022 12.7168C11.1994 12.7442 11.1979 12.7719 11.1979 12.8C11.1979 13.2418 11.5561 13.6 11.9979 13.6C12.6077 13.6 12.7238 13.276 12.8409 12.9491C12.9163 12.7388 12.9921 12.5273 13.2 12.4C13.8613 11.9952 14.4 11.2782 14.4 10.4C14.4 9.07452 13.3255 8 12 8C11.1107 8 10.3353 8.48415 9.92157 9.19942C9.70033 9.58187 9.83102 10.0713 10.2135 10.2925ZM11.1979 15.2C11.1979 14.7582 11.5561 14.4 11.9979 14.4C12.4397 14.4 12.7979 14.7582 12.7979 15.2C12.7979 15.6418 12.4397 16 11.9979 16C11.5561 16 11.1979 15.6418 11.1979 15.2Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqSidebar);
export default __webpack_public_path__ + "static/media/faq-sidebar.d8d25398ffb148507d59467493c68126.svg";
export { ForwardRef as ReactComponent };